import React from 'react';

const About = () => {
  return (
    // mt-24 ensures it clears your fixed header
    <div className="mt-24 mb-20 px-4 max-w-4xl mx-auto animate-in fade-in duration-700">
      
      {/* Main Content Card */}
      <div className="bg-white/80 backdrop-blur-md rounded-[2.5rem] p-8 md:p-14 shadow-xl border border-white">
        
        <header className="mb-10">
          <h1 className="text-4xl font-black text-slate-900 tracking-tight">About Us</h1>
          <div className="h-1.5 w-20 bg-gradient-to-r from-indigo-500 to-purple-600 rounded-full mt-4"></div>
        </header>

        <section className="space-y-8 text-slate-700 leading-relaxed">
          <p className="text-lg">
            Welcome to <span className="font-bold text-indigo-600">Pass-Photo</span>. 
            This platform provides a simple and efficient way to create passport-size photos online using AI technology.
          </p>

          <div>
            <h2 className="text-2xl font-bold text-slate-800 mb-3">What We Offer</h2>
            <p>
              Our tool allows users to upload an image and automatically generate properly formatted passport-size photos. 
              It includes background removal, resizing, and layout formatting based on commonly accepted standards.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-slate-800 mb-3">Our Goal</h2>
            <p>
              Our goal is to make passport photo creation fast, accessible, and affordable for everyone. 
              Users can generate photos directly from their mobile or desktop without requiring professional editing skills.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-slate-800 mb-3">Data & Privacy</h2>
            <p>
              We respect user privacy. Images uploaded on this platform are processed securely and are not stored permanently. 
              We do not sell or share personal data with third parties.
            </p>
          </div>

          <div>
            <h2 className="text-2xl font-bold text-slate-800 mb-3">Third-Party Services</h2>
            <p>
              This website may use trusted third-party services, including analytics and advertising partners such as Google AdSense. 
              These services may use cookies to improve user experience and deliver relevant ads.
            </p>
          </div>

          {/* Contact Box */}
          <div className="bg-slate-50 rounded-2xl p-6 border border-slate-200 mt-10">
            <h3 className="font-bold text-slate-900 mb-2">Contact</h3>
            <p className="text-sm text-slate-600 mb-3">
              For any questions, feedback, or support, please contact us at:
            </p>
            <a 
              href="mailto:darkcoder.studio@gmail.com" 
              className="text-indigo-600 font-semibold hover:text-indigo-700 transition-colors break-all"
            >
              darkcoder.studio@gmail.com
            </a>
          </div>
        </section>
      </div>
    </div>
  );
};

export default About;
